import { combineReducers } from 'redux';
import { SET_FILTER, SET_MOVIES, SET_PROFILE, SET_HIDEMODAL, SET_OPENMODAL } from '../actions/actions';

function visibilityFilter(state = '', action) {
    switch (action.type) {
        case SET_FILTER:
            return action.value;
        default:
            return state;
    }
}

function movies(state = [], action) {
    switch (action.type) {
        case SET_MOVIES:
            return action.value;
        default:
            return state;
    }
}

function user(state = '', action){
    switch (action.type) {
        case SET_PROFILE:
            return action.value;
        default:
            return state;
    }
}

function modal(state = null, action) {
    switch (action.type) {
        case SET_OPENMODAL:
            return action.value;
        case SET_HIDEMODAL:
            return null
        default:
            return state;    
    }
}

const moviesApp = combineReducers({
    visibilityFilter,
    movies,
    user,
    modal
});

export default moviesApp;